import { StatsDebugger } from './debugger';

export function StatsDebuggerFactory(): StatsDebugger {
  return new StatsDebugger(console);
}
